import { FormControl, FormGroup } from '@angular/forms';
import { SearchModelV2 } from '../search-model-v2';

/**
 * Search model for the team members listing.
 *
 * Converted from the legacy SearchModel. The raw SQL it used to carry:
 *
 *   query:  (q) => q
 *     ? `sub.principal_id ILIKE '%q%' AND hdr.status!='DELETED'`
 *     : `hdr.status!='DELETED'`
 *   table:  'app_mst_link_subject_to_grp'
 *   joins:  LEFT JOIN app_login_principal sub ON hdr.app_subject_guid = sub.subject_guid
 *   queryCallbacks: { rank: r => `hdr.rank='r'` }
 *
 * The component maps those onto criteria the users-team endpoint understands:
 * the keyword onto `search_word` (LinkSubjectToTeamUow joins app_login_principal
 * itself and ILIKEs principal_id, title and rank) and rank onto `rank`.
 */
export const TeamMemberSearchModel: SearchModelV2 = {
    label: {
        rank: 'Rank'
    },
    dataType: {
        rank: ['select', ['OWNER', 'ADMIN', 'MEMBER']]
    },
    form: new FormGroup({
        rank: new FormControl()
    }),
    options: {
        rank: {}
    }
}
